import { useEventListener } from "@react-hookz/web";
import React from "react";

const secretWord = "boo";

const isEditable = (target: EventTarget | null) =>
  target instanceof HTMLElement && (target.isContentEditable || target.matches("input, textarea, select"));

/** Typing "boo" outside a text field sends a ghost across the screen. Never intercepts the keystroke. */
export const HalloweenGhost = () => {
  const typed = React.useRef("");
  const [visible, setVisible] = React.useState(false);

  useEventListener(globalThis, "keydown", (event: KeyboardEvent) => {
    if (event.key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey || isEditable(event.target)) return;
    typed.current = (typed.current + event.key.toLowerCase()).slice(-secretWord.length);
    if (typed.current === secretWord) setVisible(true);
  });

  if (!visible) return null;

  return (
    <div
      aria-hidden="true"
      className="animate-ghost-drift motion-reduce:animate-ghost-fade pointer-events-none fixed bottom-8 left-0 z-50 flex items-center gap-2"
      onAnimationEnd={() => setVisible(false)}
    >
      <span className="scale-150 text-screenTitle">👻</span>
      <span className="rounded-full bg-white px-2 py-1 text-normal font-semibold shadow-back">
        Boo! Happy Halloween from Qwick
      </span>
    </div>
  );
};
